import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-top">
          <a href="/" className="logo">
            <img src="/images/prive.png" alt="Prive Mobility" className="logo-image" />
          </a>

          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>

          <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <button 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => handleNavigation('/')}
            >
              <span className="nav-icon">🏠</span>
              Inicio
            </button>
            <button 
              className={`nav-link ${isActive('/flota') ? 'active' : ''}`}
              onClick={() => handleNavigation('/flota')}
            >
              <span className="nav-icon">🚗</span>
              Flota
            </button>
            <button 
              className={`nav-link ${isActive('/ubicaciones') ? 'active' : ''}`}
              onClick={() => handleNavigation('/ubicaciones')}
            >
              <span className="nav-icon">📍</span>
              Ubicaciones
            </button>
            <button 
              className={`nav-link ${isActive('/adicionales') ? 'active' : ''}`}
              onClick={() => handleNavigation('/adicionales')}
            >
              <span className="nav-icon">➕</span>
              Adicionales
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
